import React, { useState } from 'react';
import { FiCpu } from 'react-icons/fi';
import { useTheme } from '../../contexts/ThemeContext';
import { HandoffDialog } from './HandoffDialog';

interface HandoffButtonProps {
  manifestId: string;
}

export const HandoffButton: React.FC<HandoffButtonProps> = ({ manifestId }) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const { darkMode } = useTheme();

  return (
    <>
      <button
        className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 flex items-center"
        onClick={() => setDialogOpen(true)}
      >
        <FiCpu className="mr-2 flex-shrink-0" />
        <span className="text-center leading-tight">Handoff to<br />External Agent</span>
      </button>

      {dialogOpen && (
        <HandoffDialog
          isOpen={dialogOpen}
          onClose={() => setDialogOpen(false)}
          manifestId={manifestId}
        />
      )}
    </>
  );
};
